import { create } from 'zustand';

interface SelectedBrandState {
  brandId: string | null;
  setBrandId: (brandId: string | null) => void;
}

export const useBrandStore = create<SelectedBrandState>((set) => ({
  brandId: null,
  setBrandId: (brandId) => set({ brandId }),
}));
